import { render, staticRenderFns } from "./loading-new.vue?vue&type=template&id=d1cf81cc&scoped=true&"
import script from "./loading-new.vue?vue&type=script&lang=js&"
export * from "./loading-new.vue?vue&type=script&lang=js&"
import style0 from "./loading-new.vue?vue&type=style&index=0&id=d1cf81cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1cf81cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1cf81cc')) {
      api.createRecord('d1cf81cc', component.options)
    } else {
      api.reload('d1cf81cc', component.options)
    }
    module.hot.accept("./loading-new.vue?vue&type=template&id=d1cf81cc&scoped=true&", function () {
      api.rerender('d1cf81cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/loading-new.vue"
export default component.exports